export interface ChatSdkUser {
  userId: string;
  name: string;
}

let initialized = false;

/**
 * 在登录授权成功后加载客服 Chat SDK（幂等，仅首次调用生效）
 *
 * - 脚本地址由 NX_PUBLIC_CHAT_SDK_SRC 注入
 * - SDK 环境标识由 NX_PUBLIC_CHAT_SDK_ENV 注入
 */
export const initChatSdk = (user: ChatSdkUser) => {
  const src = import.meta.env.NX_PUBLIC_CHAT_SDK_SRC;

  if (!src || initialized) {
    return;
  }

  initialized = true;

  const w = window as unknown as {
    CHAT_SDK_CONFIG?: Record<string, unknown>;
    $chat?: unknown[][];
  };

  // 约定式自动初始化：脚本加载后自动 init（设置后无需再调用 ChatSDK.init）
  w.CHAT_SDK_CONFIG = {
    position: 'bottom-left',
    env: import.meta.env.NX_PUBLIC_CHAT_SDK_ENV || 'prod',
  };

  // 先注入访客信息（SDK 加载后自动消化积压命令）
  const $chat = (w.$chat = w.$chat || []);
  $chat.push(['set', 'user:user_id', [String(user.userId)]]);
  $chat.push(['set', 'user:contact_name', [user.name]]);
  $chat.push(['set', 'user:web_url', [window.location.host]]);

  // 动态加载 SDK
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.body.appendChild(script);
};
